import { EmployeeBasicViewModel } from '../../shared/viewModels/employeeBasicViewModel';

export class IncidentChannelViewModel {
  public id: number;
  public title: string;
  public active: boolean;
  public accountId: number;
  public users: EmployeeBasicViewModel[];
}
